// Force webpack to include the process polyfill in the main bundle
// This ensures 'process' is defined globally before any lazy chunks load
import process from 'process/browser';
window.process = process;
